import DOSSIER from './DOSSIER/content';
import DEPOT_DOC from './DEPOT_DOC/content';
import STATUT_DOC from './STATUT_DOC/content';
import QUITUS from './QUITUS/content';
import DEPOT_PASS_FUT_DOC from './DEPOT_PASS_FUT_DOC/content';
import SPEC_DOC from './SPEC_DOC/content';
import ARCHIVE from './ARCHIVE/content';
import AJOUT_DOC from './AJOUT_DOC/content';
import INVIT_CLIENT from './INVIT_CLIENT/content';
import LIST_CLIENT from './LIST_CLIENT/content';
import QUEST_MUTUAL from './QUEST_MUTUAL/content';
import QUEST_CLIENT from './QUEST_CLIENT/content';
import SUPP_CLIENT from './SUPP_CLIENT/content';
import CLIENT_FAV from './CLIENT_FAV/content';
import RECHERC_CLIENT from './RECHERC_CLIENT/content';
import INVIT_FOURN from './INVIT_FOURN/content';
import RDS_2 from './RDS_2/content';
import ACCES_DOSS from './ACCES_DOSS/content';
import FOURN_FAV from './FOURN_FAV/content';
import UPLOAD_QUITUS_FOURN from './UPLOAD_QUITUS_FOURN/content';
import SUPP_FOURN from './SUPP_FOURN/content';
import CONSUL_OPER from './CONSUL_OPER/content';
import CREATE_OPER from './CREATE_OPER/content';
import SELECT_DOC from './SELECT_DOC/content';
import ACCESS_OPER from './ACCESS_OPER/content';
import ADD_TO_OPER from './ADD_TO_OPER/content';
import QUITUS_OPER from './QUITUS_OPER/content';
import DELETE_FROM_OPER from './DELETE_FROM_OPER/content';
import CLOSE_OPER from './CLOSE_OPER/content';
import AJOUT_ETAB from './AJOUT_ETAB/content';
import PARAM_ENT from './PARAM_ENT/content';
import GESTION_USER from './GESTION_USER/content';
import INFO_RAPP_HEBDO from './INFO_RAPP_HEBDO/content';
import ROLE from './ROLE/content';
import PARAM_COMPT from './PARAM_COMPT/content';
import MDP from './MDP/content';
import NB_CLIENTS from './NB_CLIENTS/content';

export default [
  DOSSIER,
  DEPOT_DOC,
  PARAM_COMPT,
  MDP,
  STATUT_DOC,
  DEPOT_PASS_FUT_DOC,
  SPEC_DOC,
  ARCHIVE,
  AJOUT_DOC,
  INVIT_CLIENT,
  LIST_CLIENT,
  QUEST_MUTUAL,
  QUEST_CLIENT,
  SUPP_CLIENT,
  CLIENT_FAV,
  RECHERC_CLIENT,
  INVIT_FOURN,
  RDS_2,
  ACCES_DOSS,
  FOURN_FAV,
  UPLOAD_QUITUS_FOURN,
  SUPP_FOURN,
  CONSUL_OPER,
  CREATE_OPER,
  SELECT_DOC,
  ACCESS_OPER,
  ADD_TO_OPER,
  QUITUS_OPER,
  DELETE_FROM_OPER,
  CLOSE_OPER,
  AJOUT_ETAB,
  PARAM_ENT,
  GESTION_USER,
  INFO_RAPP_HEBDO,
  ROLE,
  QUITUS,
  NB_CLIENTS
];
